import type { PartSvgProps } from './types'

export default function BraceSvg ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  accent = 'var(--gs-part-accent, #E85D04)',
  width = 120,
  height = 80
}: PartSvgProps) {
  return (
    <svg viewBox="0 0 120 80" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      {/* Buffer tube stub */}
      <rect x="8" y="32" width="50" height="16" rx="8"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Brace body — shorter than stock */}
      <path d="M 58 24 L 106 20 L 112 28 L 112 52 L 106 60 L 58 56 Z"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      {/* Strap band 1 (horizontal, upper) */}
      <rect x="66" y="24" width="34" height="8" rx="2"
            fill="none" stroke={accent} strokeWidth="1.2" />
      {/* Strap band 2 (horizontal, lower) */}
      <rect x="66" y="48" width="34" height="8" rx="2"
            fill="none" stroke={accent} strokeWidth="1.2" />
      {/* Butt pad */}
      <rect x="106" y="22" width="8" height="36" rx="2"
            fill={fill} stroke={stroke} strokeWidth="1.2" />
    </svg>
  )
}
